<ng-template #PasswordChange>
    <div class="centered-content">
        <div
            style="display: flex; justify-content: center; align-items: center; flex-direction: column; background: #e6e6e6">
            <div
                style="max-width: 736px; width: 100%; height: auto; margin: 0 auto; padding: 20px 44px 40px; background: #fff">
                <div nxLayout="grid maxwidth" *ngIf="!passwordVerifiedSuccessfully">
                    <div nxRow>
                        <div nxCol="12" style="text-align: center;">
                            <h3 nxHeadline="subsection-medium" translate>
                                profile.texts.password-change</h3>
                            <p translate>
                                profile.texts.password-change-info
                            </p>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol="12">
                            <form [formGroup]="form" class="modal-form-report" (submit)="changePassword($event)">

                                <nx-formfield label="{{ 'profile.texts.password-change-current' | translate }}">
                                    <input required nxInput #currentPassword type="password"
                                        nxAriaLabel="{{ 'profile.texts.password-change-current' | translate }}"
                                        formControlName="currentPassword" />
                                    <nx-password-toggle [control]="currentPassword"
                                        nxFormfieldSuffix></nx-password-toggle>
                                    <nx-error nxFormfieldError appearance="text"
                                        *ngIf="form.controls?.currentPassword?.errors?.required">
                                        {{ 'change-password.required' | translate }}
                                    </nx-error>
                                    <nx-error nxFormfieldError appearance="text" *ngIf="form?.errors?.currentPassword">
                                        {{ 'change-password.invalid-password' | translate }}
                                    </nx-error>
                                </nx-formfield>

                                <nx-formfield label="{{ 'profile.texts.password-change-new' | translate }}">
                                    <input required nxInput #newPassword type="password"
                                        nxAriaLabel="{{ 'profile.texts.password-change-new' | translate }}"
                                        formControlName="newPassword" />
                                    <nx-password-toggle [control]="newPassword" nxFormfieldSuffix></nx-password-toggle>
                                    <nx-error nxFormfieldError appearance="text"
                                        *ngIf="form.controls?.newPassword?.errors?.required || form?.errors?.newPassword == 'required'">
                                        {{ 'change-password.required' | translate }}
                                    </nx-error>

                                    <nx-error nxFormfieldError appearance="text"
                                        *ngIf="form?.errors?.newRepeat == 'mismatch'">
                                        {{ 'change-password.mismatch' | translate }}
                                    </nx-error>

                                    <nx-error nxFormfieldError appearance="text" *ngFor="let error of validationErrors">
                                        {{ 'change-password.' + error | translate }}
                                    </nx-error>

                                    <div success nxFormfieldError appearance="text"
                                        *ngFor="let success of getSuccessMessages()">
                                        <cpc-icon icon="check" iconSet="ndbx" style="font-size: 20px;"></cpc-icon>
                                        {{ 'change-password.' + success | translate }}
                                    </div>
                                </nx-formfield>
                                <nx-formfield label="{{ 'profile.texts.password-change-new-repeat' | translate }}">
                                    <input required nxInput #newRepeat type="password"
                                        nxAriaLabel="{{ 'profile.texts.password-change-new-repeat' | translate }}"
                                        formControlName="newRepeat" />
                                    <nx-password-toggle [control]="newRepeat" nxFormfieldSuffix></nx-password-toggle>
                                    <nx-error nxFormfieldError appearance="text"
                                        *ngIf="form.controls?.newRepeat?.errors?.required || form?.errors?.newRepeat == 'required'">
                                        {{ 'change-password.required' | translate }}
                                    </nx-error>
                                    <nx-error nxFormfieldError appearance="text"
                                        *ngIf="form?.errors?.newRepeat == 'mismatch'">
                                        {{ 'change-password.mismatch' | translate }}
                                    </nx-error>
                                </nx-formfield>
                                <div nxRow rowJustify="center">
                                    <button nxButton="primary normal" type="submit">
                                        <span translate>profile.texts.send</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div nxLayout="grid maxwidth" *ngIf="passwordVerifiedSuccessfully">
                    <div nxRow>
                        <div nxCol="12" style="text-align: center;">
                            <h3 nxHeadline="subsection-medium" translate>
                                profile.texts.check-sms-code</h3>
                        </div>
                    </div>
                    <form [formGroup]="formSms" class="modal-form-report" (submit)="checkSMSCode($event)">
                        <div nxRow>
                            <div nxCol="12">
                                <nx-formfield label="{{ 'profile.texts.sms-code' | translate }}">
                                    <input required nxInput type="text" [class]="isRed()"
                                        nxAriaLabel="{{ 'profile.texts.sms-code' | translate }}"
                                        formControlName="smsCode" />
                                </nx-formfield>
                            </div>
                            <div nxCol="12" class="nx-margin-bottom-m resend-sms">
                                <nx-link>
                                    <a href="javascript:void(0);" (click)="resend()"
                                        translate>profile.texts.resent-sms-code</a>
                                </nx-link>
                            </div>
                            <div nxCol="12">
                                <div nxRow rowJustify="center">
                                    <button nxButton="primary normal" type="submit">
                                        <span translate>profile.texts.send</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

</ng-template>